import React, { useCallback, useEffect, useState } from "react";
import CanvasContainer from "../../../canvas/CanvasContainer";
import styles from "./DSICanvas.module.css";
import { CompaniesList, ProjectsList } from "../../components";
import { isNonEmptyArray, searchInTree } from "../../../../common/utils";
import { useApi, useEffectOnce } from "../../../../common/hooks";
import { BackOfficeService } from "../../../../api";

export default function DSICanvas({ companies }) {
	const { call: getAllProjectsDetails } = useApi(BackOfficeService.getAllProjectsDetails);
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [selectedProject, setSelectedProject] = useState(null);
	const [projectsRequest, setProjectsRequest] = useState(null);
	const isValidCompany = useCallback(
		(company) => company.type === "COMPANY" || company.type === "BUSINESS_UNIT" || company.type === "CONSORTIUM",
		[]
	);
	useEffect(() => {
		if (selectedCompany) {
			setSelectedCompany(
				searchInTree({ tree: companies, idToFind: selectedCompany?.id, additionalConditions: isValidCompany })
			);
		}
	}, [companies, selectedCompany, isValidCompany]);
	const handleSelectCompany = (cmp) => {
		setSelectedCompany(cmp);
		setSelectedProject(null);
	};
	useEffect(() => {
		if (selectedCompany?.id) {
			setProjectsRequest(
				() =>
					({ page, limit }) =>
						getAllProjectsDetails({ companyId: selectedCompany.id }, { page, limit })
			);
		}
	}, [selectedCompany, getAllProjectsDetails]);
	useEffectOnce(
		() => {
			handleSelectCompany(companies[0]);
		},
		[],
		() => selectedCompany === null && isNonEmptyArray(companies)
	);

	const handleSelectProject = (pr) => {
		setSelectedProject(pr);
	};
	return (
		<>
			{(!selectedCompany || !selectedProject) && (
				<>
					<div className={styles["left-panel"]}>
						<CompaniesList
							companies={companies || []}
							selectedCompany={selectedCompany}
							onClickRow={handleSelectCompany}
						/>
					</div>
					<div className={styles["middle-panel"]}>
						<ProjectsList
							isCanvas
							projectsRequest={projectsRequest}
							selectedCompany={selectedCompany}
							onClickRow={handleSelectProject}
						/>
					</div>
				</>
			)}
			{selectedCompany && selectedProject && (
				<CanvasContainer
					companies={companies}
					companyName={selectedCompany?.companyName}
					getDocumentMethod="getCompanyProjectDocuments"
					getUserMethod="getCompanyProjectUsers"
					projectId={selectedProject.id}
					selectedCompany={selectedCompany}
					selectedProject={selectedProject}
					onSelectCompany={handleSelectCompany}
					onSelectProject={handleSelectProject}
				/>
			)}
		</>
	);
}
